import BankIcon from '~/images/icons/bank-building.svg';
import CardIcon from '~/images/icons/card.svg';
import PayPalLogo from '~/images/icons/paypal-logo-color.svg';
import cx from 'classnames';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';

const CalmPaymentTabs = observer(
  ({
    handleStripeTabClick,
    handlePaypalTabClick,
    handlePlaidTabClick,
    handleBacsTabClick,
    paypalTabClass,
    isSubscription,
    country,
  }) => (
    <div
      className={cx({
        hidden: store.donateForm.embedded,
      })}
      id='calm-payment-tabs'
    >
      <p className='calm-payment-tab-label'>Select payment method</p>
      <nav>
        <ul className='calm-payment-tab-list'>
          <li
            className={cx('stripe-donate-button', {
              active: store.donateForm.paymentTab === 'stripe',
            })}
            onClick={handleStripeTabClick}
          >
            <img src={CardIcon} />
            <div>Card</div>
          </li>
          {isSubscription && country == 'us' && (
            <li
              className={cx('ach-donate-button', {
                active: store.donateForm.paymentTab === 'plaid',
              })}
              onClick={handlePlaidTabClick}
            >
              <img src={BankIcon} />
              <div>Link Bank</div>
            </li>
          )}
          {store.donateForm.isPaypalAvailable && (
            <li
              className={`paypal-donate-button ${paypalTabClass()}`}
              onClick={handlePaypalTabClick}
            >
              <img src={PayPalLogo} />
              <div>PayPal</div>
            </li>
          )}
          {country == 'uk' && (
            <li
              className={cx('bacs-donate-button', {
                active: store.donateForm.paymentTab === 'bacs',
              })}
              onClick={handleBacsTabClick}
            >
              <img src={BankIcon} />
              <div>Bank Transfer</div>
            </li>
          )}
        </ul>
      </nav>
    </div>
  )
);

export default CalmPaymentTabs;
